import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  depth: 1,
};

const depthSlice = createSlice({
  name: 'depth',
  initialState,
  reducers: {
    setDepth(state, action) {
      const { payload } = action;
      state.depth = payload;
    },
  },
});

export const { setDepth } = depthSlice.actions;
export default depthSlice.reducer;
